<template>
    <div class="message" :class="'message--' + status.toLowerCase()">
        {{message}}
    </div>
</template>

<script>
    export default {
        name: 'Message',
        props: {
            status: String,
            message: String,
        },
    }
</script>


// WEBPACK FOOTER //
// src/modules/components/Message.vue